export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15010.af5d32c7.jpg";